// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom styles for react-datepicker */
.react-datepicker {
  font-family: Arial, sans-serif;
  font-size: 0.9rem;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.react-datepicker__header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #ced4da;
  padding: 8px 0;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.react-datepicker__current-month {
  font-weight: bold;
  color: #495057;
}

.react-datepicker__day-name, 
.react-datepicker__day {
  width: 2.5rem;
  line-height: 2.5rem;
  margin: 0.166rem;
  color: #495057;
}

.react-datepicker__day:hover {
  background-color: #e9ecef;
  border-radius: 50%;
}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected {
  background-color: #007bff;
  color: #fff;
  border-radius: 50%;
}

.react-datepicker__day--outside-month {
  color: #ced4da;
}

.react-datepicker__day--today {
  font-weight: bold;
  color: #007bff;
}

.react-datepicker__navigation--previous {
  border-right-color: #007bff;
}

.react-datepicker__navigation--next {
  border-left-color: #007bff;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #007bff;
  color: #fff;
}

.react-datepicker__close-icon::after {
  background-color: #007bff;
  color: #fff;
}

.custom-calendar {
  position: relative;
  /* z-index: 9999; */
  top: 0px;
}
.react-datepicker-wrapper {
    width: 100%;
}
.react-datepicker__day--today {
    color: #000000;
}`, "",{"version":3,"sources":["webpack://./src/Sidebar/Datepicker.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;AACV;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB","sourcesContent":["/* Custom styles for react-datepicker */\r\n.react-datepicker {\r\n  font-family: Arial, sans-serif;\r\n  font-size: 0.9rem;\r\n  background-color: #fff;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 0.25rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.react-datepicker__header {\r\n  background-color: #f8f9fa;\r\n  border-bottom: 1px solid #ced4da;\r\n  padding: 8px 0;\r\n  border-top-left-radius: 0.25rem;\r\n  border-top-right-radius: 0.25rem;\r\n}\r\n\r\n.react-datepicker__current-month {\r\n  font-weight: bold;\r\n  color: #495057;\r\n}\r\n\r\n.react-datepicker__day-name, \r\n.react-datepicker__day {\r\n  width: 2.5rem;\r\n  line-height: 2.5rem;\r\n  margin: 0.166rem;\r\n  color: #495057;\r\n}\r\n\r\n.react-datepicker__day:hover {\r\n  background-color: #e9ecef;\r\n  border-radius: 50%;\r\n}\r\n\r\n.react-datepicker__day--selected,\r\n.react-datepicker__day--keyboard-selected {\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  border-radius: 50%;\r\n}\r\n\r\n.react-datepicker__day--outside-month {\r\n  color: #ced4da;\r\n}\r\n\r\n.react-datepicker__day--today {\r\n  font-weight: bold;\r\n  color: #007bff;\r\n}\r\n\r\n.react-datepicker__navigation--previous {\r\n  border-right-color: #007bff;\r\n}\r\n\r\n.react-datepicker__navigation--next {\r\n  border-left-color: #007bff;\r\n}\r\n\r\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\r\n  background-color: #007bff;\r\n  color: #fff;\r\n}\r\n\r\n.react-datepicker__close-icon::after {\r\n  background-color: #007bff;\r\n  color: #fff;\r\n}\r\n\r\n.custom-calendar {\r\n  position: relative;\r\n  /* z-index: 9999; */\r\n  top: 0px;\r\n}\r\n.react-datepicker-wrapper {\r\n    width: 100%;\r\n}\r\n.react-datepicker__day--today {\r\n    color: #000000;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
